import { makeDefaultStylingContext } from '../tornado/utils/style';
import { SCREEN_HEIGHT } from '../tornado/utils/sizes';

export const defaultContext = makeDefaultStylingContext();

export const RENDERER_HEIGHT = {
  ...SCREEN_HEIGHT,
};
